import {Colors} from "@bounce/shared/ui";
import {CustomSelectType} from "./CustomSelect";

export const getSelectStyles = (type: CustomSelectType) => {
  switch (type) {
    case "consumer":
    default:
      return {
        textColor: Colors.primary._800,
        backgroundColor: "white",
        borderColor: Colors.primary._200,
        hoverColor: Colors.primary._100,
        iconColor: Colors.primary._600,
      };
  }
};
